import { FC, JSX, useEffect, useState } from "react";
import "./Categories.scss";
import MainNavbar from "../../components/MainNavbar/MainNavbar";
import { Card, Col, Container, Row } from "react-bootstrap";
import { BvIcon } from "bevi-icon";
import Skeleton from "react-loading-skeleton";
import { useAgentsCategories } from "../../providers/Agents/AgentsCategories/AgentsCategoriesProvider";
import { AgentsCategoryModel } from "../../models/Agents/AgentsCategory/AgentsCategoryModel";
import { Link } from "react-router-dom";

interface CategoriesProps { }

const Categories: FC<CategoriesProps> = () => {
  const [allCategories, setAllCategories] = useState<AgentsCategoryModel[]>([]);

  const { handleListCategories, categoriesList, isLoading } =
    useAgentsCategories();

  useEffect(() => {
    handleListCategories();
  }, []);

  useEffect(() => {
    setAllCategories(categoriesList);
  }, [categoriesList]);

  const handleSearch = (search: string) => {
    if (!search) {
      setAllCategories(categoriesList);
    } else {
      const locate = categoriesList.filter((x: AgentsCategoryModel) =>
        x?.name?.toLowerCase().includes(search.toLowerCase())
      );

      setAllCategories(locate);
    }
  };

  return (
    <>
      <MainNavbar />
      <div className="Categories" data-testid="Categories">
        <div
          className="background-wrapper"
          style={{
            background: `url(${process.env.PUBLIC_URL}/assets/img/background-wrapper-2.png) no-repeat center center`,
            backgroundSize: "cover",
            height: "383px",
          }}
        >
          <Container>
            <Row>
              <Col md={12}>
                <div className="d-flex text-center justify-content-center align-items-center flex-column mt-5">
                  <h1>Categorias</h1>
                  <span className="sub-title mt-2">
                    Aqui você encontra todos os conteúdos<br className="d-block d-sm-none" /> organizados por categorias.
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col
                md={12}
                className="d-flex justify-content-center align-items-center flex-column mt-4"
              >
                <input
                  type="text"
                  className="form-control"
                  placeholder="Digite a categoria"
                  aria-label="Digite a categoria"
                  aria-describedby="basic-addon1"
                  onChange={(e) => {
                    handleSearch(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <>
              {!isLoading ? (
                <>
                  <div className="contents mt-5">
                    {allCategories.map(
                      (x: AgentsCategoryModel, key: number) => (
                        <div key={key}>
                          <Link to={`/articles/categories/view/${x?.id}`}>
                            <Card>
                              <div className="d-flex flex-column h-100 align-items-center text-center p-4 justify-content-between">
                                <h5>{x?.name}</h5>
                                <span className="description-categories">{x?.description}</span>
                                <span>
                                  Saiba mais
                                  <BvIcon name="arrowForward" variant="duo" weight={600} width={12} height={12} />
                                </span>
                              </div>
                            </Card>
                          </Link>
                        </div>
                      )
                    )}
                  </div>
                </>
              ) : (
                <div className="mb-4 d-flex mt-5">
                  <Skeleton
                    className="ms-3"
                    borderRadius={32}
                    height={227}
                    width={242}
                  />
                  <Skeleton
                    className="ms-3"
                    borderRadius={32}
                    height={227}
                    width={242}
                  />
                  <Skeleton
                    className="ms-3"
                    borderRadius={32}
                    height={227}
                    width={242}
                  />
                  <Skeleton
                    className="ms-3"
                    borderRadius={32}
                    height={227}
                    width={242}
                  />
                  <Skeleton
                    className="ms-3"
                    borderRadius={32}
                    height={227}
                    width={242}
                  />
                </div>
              )}
            </>
          </Container>
        </div>
      </div>
    </>
  );
};

export default Categories;
